import { useParams } from "react-router-dom";
import ViewUsers from "@swivu/shared-ui/src/components/ViewUsers.js";
import { useSettings } from "../hooks/useSettings.js";

const ViewUsersPublic = () => {
  const { timezone } = useSettings();
  const { id, slug } = useParams<{ id: string; slug: string }>();
  return (
    <ViewUsers.Provider timezone={timezone} api="public" id={id!} slug={slug!}>
      <div className="py-4">
        <ViewUsers />
      </div>
    </ViewUsers.Provider>
  );
};

export default ViewUsersPublic;
